import { render, staticRenderFns } from "./PlanningAddOriginView.vue?vue&type=template&id=0436164e&scoped=true"
import script from "./PlanningAddOriginView.vue?vue&type=script&lang=ts"
export * from "./PlanningAddOriginView.vue?vue&type=script&lang=ts"
import style0 from "./PlanningAddOriginView.vue?vue&type=style&index=0&id=0436164e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0436164e",
  null
  
)

export default component.exports